var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.7812H11V20.7812H4C2.9 20.7812 2 19.8912 2 18.7812V6.78122C2 5.67122 2.89 4.78122 4 4.78122H10L12 6.78122H20C21.1 6.78122 22 7.67122 22 8.78122V10.9512L20.41 9.37122L20 8.95122V8.78122H4V18.7812ZM23 14.7812V21.7812C23 22.8912 22.11 23.7812 21 23.7812H15C13.9 23.7812 13 22.8912 13 21.7812V12.7812C13 11.6812 13.9 10.7812 15 10.7812H19L23 14.7812ZM21 15.7812H18V12.7812H15V21.7812H21V15.7812Z",
    fill: "#E0565F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIcon1);
export default __webpack_public_path__ + "static/media/welcome-icon-1.39b96bed.svg";
export { ForwardRef as ReactComponent };